module.exports = __webpack_public_path__ + "assets/img/powershell.e17c6005.svg";